import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDescriptionCLogic } from './hooks/useNonprofitDescriptionCLogic';
import { NonprofitDescriptionCForm } from './NonprofitDescriptionCForm';

export const EddNonprofitDescriptionC = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDescriptionCLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDescriptionC.content')}
        textCustomStyle='text-text-main-primary text-[16px] whitespace-pre-line'
        content={t('organic.nonprofitDescriptionC.title')}>
        <NonprofitDescriptionCForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
